import { LanguagesEnum } from '@/api/enums';
import { PhishingLanguagesEnum } from '@/api/enums/phishing-languages.enum';
import { CampaignStatusesEnum } from './campaign.type';
import { CampaignPhishingSignEnum } from './campaigns.type';

export enum CatalogueUsageFilterEnum {
  SHOW_UNUSED = 'show-unused',
  SHOW_ALL = 'show-all',
  SHOW_USED = 'show-used',
}

export type CatalogueVariant = {
  templateId: string;
  language: PhishingLanguagesEnum | null;
};

export type CatalogueVariantWithLanguage = CatalogueVariant & {
  language: PhishingLanguagesEnum;
};

export const hasVariantLanguage = (
  variant: CatalogueVariant,
): variant is CatalogueVariantWithLanguage => !!variant.language;

export type CampaignCatalogueItem = {
  id: string;
  name: string;
  description?: string | null;
  thumbnailUrl?: string | null;
  phishingSign?: CampaignPhishingSignEnum | null;
  difficulty?: number | null;
  language?: LanguagesEnum | null;
  hasActiveSimulation?: boolean;
  simulationStatus?: CampaignStatusesEnum | null;
  benchmarkClickRate?: number | null;
  benchmarkSubmitRate?: number | null;
  masterTemplateId?: string | null;
  variants?: CatalogueVariant[];
};

export type CampaignCatalogueResponse = {
  items: CampaignCatalogueItem[];
  total: number;
  skip: number;
  take: number;
  view?: 'master' | 'template';
};

export type FeaturedCampaignTemplatesResponse = {
  items: CampaignCatalogueItem[];
  isSeasonal: boolean;
  view?: 'master' | 'template';
};

export type GetCatalogueTemplatesParams = {
  usageFilter?: CatalogueUsageFilterEnum;
  filters?: any;
  take?: number;
  skip?: number;
  sort?: string[];
  sortNulls?: 'first' | 'last';
};
